const STORAGE_KEY = 'accountantExternalId';

export const getAccountantExternalId = (): string | null => {
  const fromParams = new URLSearchParams(window.location.search).get('externalId');
  if (fromParams) {
    sessionStorage.setItem(STORAGE_KEY, fromParams);
    return fromParams;
  }
  return sessionStorage.getItem(STORAGE_KEY);
};
